// Admin: the player report (shared/player-report.ts), loaded on request, with a button that copies it whole.
import type { ClientMsg } from '../shared/protocol.ts';
import type { PlayerReportRow } from '../shared/player-report.ts';
import { esc, full } from './fmt.ts';
import { toast } from './dialog.ts';

let send: (m: ClientMsg) => void = () => {};
let rerender: () => void = () => {};
let rows: PlayerReportRow[] | null = null;
let loading = false;
const round1 = (n: number) => Math.round(n * 10) / 10;

export function bindPlayerReport(o: { send: typeof send; render: () => void }) { send = o.send; rerender = o.render; }

export function onPlayerReport(r: PlayerReportRow[]) { rows = r; loading = false; rerender(); }

export function playerReportSection(): string {
  const head = `<div class="row between" style="margin-top:16px"><h3>Players</h3><span class="actions">${rows ? '<button class="btn small" data-act="prep-copy">Copy report</button>' : ''}<button class="btn small" data-act="prep-load"${loading ? ' disabled' : ''}>${rows ? 'Refresh' : loading ? 'Loading…' : 'Load'}</button></span></div>`;
  if (!rows) return head;
  const tr = rows.map((r) => `<tr><td>${esc(r.name)}${r.admin ? ' <span class="muted">admin</span>' : ''}${r.playtest ? ' <span class="muted">test</span>' : ''}</td><td>${full(r.level)}</td><td>${r.playHours} h</td><td>${r.sessions.activeDays}</td><td>${r.sessions.hoursPerActiveDay} h</td><td>${r.sessions.count}</td><td>${r.sessions.medianMin} min</td><td>${full(r.catches)}</td><td>${full(r.playHours ? Math.round(r.kills / r.playHours) : 0)}</td><td title="Since sessions began recording it: held by the tutorial, stopped in Kinhall, resting after wipes">${r.tally?.hours ? `${round1(r.tally.heldHours + r.tally.stoppedHours + r.tally.restHours)} of ${r.tally.hours} h` : '—'}</td></tr>`).join('');
  return `${head}<table class="tbl"><tr><th>Player</th><th>Level</th><th>Played</th><th>Days</th><th>A day</th><th>Sessions</th><th>Median</th><th>Catches</th><th>Kills/h</th><th>Not hunting</th></tr>${tr || '<tr><td colspan=10>Nobody has played yet</td></tr>'}</table>`;
}

/** Clicks for data-act="prep-*"; true when handled. */
export function playerReportClick(el: HTMLElement): boolean {
  if (el.dataset.act === 'prep-load') { loading = true; send({ t: 'admPlayers' }); rerender(); return true; }
  if (el.dataset.act === 'prep-copy' && rows) {
    navigator.clipboard.writeText(JSON.stringify({ at: new Date().toISOString(), players: rows })).then(() => toast('Player report copied.'), () => toast('Copy failed.', 'err'));
    return true;
  }
  return false;
}
